import { InjectionToken, Type } from '@angular/core';

/**
 * Dialog opened from the analysis pages to download sample assets. The
 * concrete component lives in @acquisition/ui; the app wiring provides it so
 * analysis never imports acquisition directly (which would cycle, since
 * acquisition-ui already imports @analysis/ui).
 */
export const DOWNLOAD_ASSETS_DIALOG_COMPONENT = new InjectionToken<Type<unknown>>('DOWNLOAD_ASSETS_DIALOG_COMPONENT');
